// @flow
import React from 'react'
import { Switch } from 'react-router-dom'

import Add from './Add'
import List from './List'
import Profile from './Profile'
import NoMatch from 'screens/NoMatch'
import { CustomRoute } from 'components'

function ClientsRouter() {
  return (
    <Switch>
      <CustomRoute
        exact
        path='/inicio/clientes/agregar'
        component={Add}
        isPrivate
        isProtected
      />
      <CustomRoute
        exact
        path='/inicio/clientes/mostrar'
        component={List}
        isPrivate
        isProtected
      />
      <CustomRoute
        exact
        path='/inicio/clientes/perfil/:id'
        component={Profile}
        isPrivate
      />
      <CustomRoute component={NoMatch} />
    </Switch>
  )
}

export default ClientsRouter
